<template>
  <el-container class="layout">
    <el-aside :width="collapsed ? '64px' : '220px'" class="aside">
      <div class="logo" @click="$router.push('/dashboard')">
        <img src="/favicon.ico" alt="logo" />
        <transition name="fade"><span v-if="!collapsed"> 博乐润景 · 在线 </span></transition>
      </div>
      <el-menu :default-active="activeMenu" :collapse="collapsed" background-color="#1f2d3d" text-color="#bfcbd9"
        active-text-color="#409EFF" router>
        <el-menu-item index="/dashboard"><i class="el-icon-s-home" /><span slot="title">首页</span></el-menu-item>

        <!-- <el-submenu index="/org">
          <template slot="title"><i class="el-icon-office-building"/><span>机构管理</span></template>
<el-menu-item index="/org/tree">组织机构</el-menu-item>
</el-submenu> -->

        <el-submenu index="/hr">
          <template slot="title"><i class="el-icon-user-solid" /><span>人事管理</span></template>
          <el-menu-item index="/hr/persons">人员花名册</el-menu-item>
        </el-submenu>

        <!-- <el-submenu index="/device">
          <template slot="title"><i class="el-icon-cpu"/><span>设备管理</span></template>
          <el-menu-item index="/device/list">设备列表</el-menu-item>
        </el-submenu>

        <el-submenu index="/fleet">
          <template slot="title"><i class="el-icon-truck"/><span>车辆管理</span></template>
          <el-menu-item index="/fleet/vehicles">车辆台账</el-menu-item>
        </el-submenu>

        <el-submenu index="/oa">
          <template slot="title"><i class="el-icon-date"/><span>OA考勤</span></template>
          <el-menu-item index="/oa/attendance">考勤记录</el-menu-item>
        </el-submenu>

        <el-submenu index="/map">
          <template slot="title"><i class="el-icon-location"/><span>位置监控</span></template>
          <el-menu-item index="/map/monitor">地图监控</el-menu-item>
        </el-submenu>

        <el-submenu index="/report">
          <template slot="title"><i class="el-icon-data-analysis"/><span>统计报表</span></template>
          <el-menu-item index="/report/index">运营报表</el-menu-item>
        </el-submenu> -->

        <el-submenu index="/auth">
          <template slot="title"><i class="el-icon-lock" /><span>权限管理</span></template>
          <el-menu-item index="/auth/users">用户管理</el-menu-item>
          <el-menu-item index="/auth/roles">角色/权限</el-menu-item>
        </el-submenu>

        <el-submenu index="/system">
          <template slot="title"><i class="el-icon-setting" /><span>系统设置</span></template>
          <el-menu-item index="/system/settings">参数设置</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="header">
        <div class="left">
          <el-button icon="el-icon-s-fold" @click="collapsed = !collapsed" type="text" />
          <el-breadcrumb separator="/" class="breadcrumb">
            <el-breadcrumb-item v-for="(b, i) in breads" :key="i">{{ b }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="right">
          <!-- <el-switch v-model="dark" active-text="暗" inactive-text="亮"/> -->
          <el-dropdown>
            <span class="el-dropdown-link">{{ userName }}<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>

      <el-main :class="[{ dark }]">
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
export default {
  name: 'MainLayout',
  data() {
    return { collapsed: false, dark: false }
  },
  computed: {
    activeMenu() { return this.$route.matched.length ? this.$route.matched[this.$route.matched.length - 1].path : this.$route.path },
    breads() { return this.$route.matched.map(m => (m.meta && m.meta.title) || m.name).filter(Boolean) },
    userName() { return localStorage.getItem('displayName') || '博乐润景' }
  },
  methods: {
    logout() {
      localStorage.removeItem('token')
      localStorage.removeItem('lastActiveTime')
      this.$router.replace('/login')
    }
  }
}
</script>

<style scoped>
.layout {
  height: 100vh;
}

.aside {
  background: #1f2d3d;
  color: #bfcbd9;
}

.logo {
  height: 56px;
  display: flex;
  align-items: center;
  padding: 0 12px;
  gap: 8px;
  color: #fff;
  cursor: pointer;
}

.logo img {
  width: 28px;
  height: 28px;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, .06);
}

.header .left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.breadcrumb {
  margin-left: 8px;
}

.el-main.dark {
  background: #0f172a;
  color: #e5e7eb;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>